export function hexToHSL(H: string, returnObj = false) {
  // Convert hex to RGB first
  let r: any = 0,
    g: any = 0,
    b: any = 0
  if (H.length == 4) {
    r = '0x' + H[1] + H[1]
    g = '0x' + H[2] + H[2]
    b = '0x' + H[3] + H[3]
  } else if (H.length == 7) {
    r = '0x' + H[1] + H[2]
    g = '0x' + H[3] + H[4]
    b = '0x' + H[5] + H[6]
  }
  // Then to HSL
  r /= 255
  g /= 255
  b /= 255
  const cmin = Math.min(r, g, b)
  const cmax = Math.max(r, g, b)
  const delta = cmax - cmin
  let h = 0
  let s = 0
  let l = 0

  if (delta == 0) h = 0
  else if (cmax == r) h = ((g - b) / delta) % 6
  else if (cmax == g) h = (b - r) / delta + 2
  else h = (r - g) / delta + 4

  h = Math.round(h * 60)

  if (h < 0) h += 360

  l = (cmax + cmin) / 2
  s = delta == 0 ? 0 : delta / (1 - Math.abs(2 * l - 1))
  s = +(s * 100).toFixed(1)
  l = +(l * 100).toFixed(1)

  return returnObj
    ? { h, s, l }
    : (('hsl(' + h + ',' + s + '%,' + l + '%)') as any)
}

export function hexToHsb(hex: string, returnObj = false) {
  const { h, s, l } = hexToHSL(hex, true)
  const b = l + (s / 100) * Math.min(l, 100 - l)
  const newS = b === 0 ? 0 : 2 * (1 - l / b) * 100
  return returnObj ? { h, s: newS, b } : `hsb(${h},${newS}, ${b})`
}

export function hslToHex({ h, s, l }: any) {
  l /= 100
  const a = (s * Math.min(l, 1 - l)) / 100
  const f = (n: any) => {
    const k = (n + h / 30) % 12
    const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1)
    return Math.round(255 * color)
      .toString(16)
      .padStart(2, '0') // convert to Hex and prefix "0" if needed
  }
  return `#${f(0)}${f(8)}${f(4)}`
}

export function hexToRgb(hex: string, returnObj = false) {
  let alpha = false,
    h: any = hex.slice(hex.startsWith('#') ? 1 : 0)
  if (h.length === 3) h = [...h].map((x) => x + x).join('')
  else if (h.length === 8) alpha = true
  h = parseInt(h, 16)
  const obj = {
    r: h >>> (alpha ? 24 : 16),
    g: (h & (alpha ? 0x00ff0000 : 0x00ff00)) >>> (alpha ? 16 : 8),
    b: (h & (alpha ? 0x0000ff00 : 0x0000ff)) >>> (alpha ? 8 : 0),
  }
  return returnObj
    ? obj
    : 'rgb' +
        (alpha ? 'a' : '') +
        '(' +
        obj.r +
        ', ' +
        obj.g +
        ', ' +
        obj.b +
        (alpha ? `, ${h & 0x000000ff}` : '') +
        ')'
}

export function rgbToHsb(r: any, g: any, b: any) {
  r /= 255
  g /= 255
  b /= 255
  const v = Math.max(r, g, b),
    n = v - Math.min(r, g, b)
  const h =
    n === 0
      ? 0
      : n && v === r
      ? (g - b) / n
      : v === g
      ? 2 + (b - r) / n
      : 4 + (r - g) / n
  return [60 * (h < 0 ? h + 6 : h), v && (n / v) * 100, v * 100]
}

export function hsbToRgb(h: any, s: any, b: any) {
  s /= 100
  b /= 100
  const k = (n: any) => (n + h / 60) % 6
  const f = (n: any) => b * (1 - s * Math.max(0, Math.min(k(n), 4 - k(n), 1)))
  return [255 * f(5), 255 * f(3), 255 * f(1)]
}
